var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 11.25V3.5C0 2.669.669 2 1.5 2h7.75c.412 0 .75.338.75.75v2.5c0 .412-.338.75-.75.75H4v5.25c0 .412-.338.75-.75.75H.75a.753.753 0 0 1-.75-.75zm18-8.5c0-.412.338-.75.75-.75h7.75c.831 0 1.5.669 1.5 1.5v7.75c0 .412-.338.75-.75.75h-2.5a.753.753 0 0 1-.75-.75V6h-5.25a.753.753 0 0 1-.75-.75v-2.5zM27.25 20c.412 0 .75.338.75.75v7.75c0 .831-.669 1.5-1.5 1.5h-7.75a.753.753 0 0 1-.75-.75v-2.5c0-.412.338-.75.75-.75H24v-5.25c0-.412.338-.75.75-.75h2.5zM10 29.25c0 .412-.338.75-.75.75H1.5C.669 30 0 29.331 0 28.5v-7.75c0-.412.338-.75.75-.75h2.5c.412 0 .75.338.75.75V26h5.25c.412 0 .75.338.75.75v2.5z"}));
}

Expand.defaultProps = {"viewBox":"0 0 28 32"};

module.exports = Expand;

Expand.default = Expand;
